import { useState } from 'react'
import 'jqueryui'

import {
  EuiFlexItem,
  EuiPanel,
  EuiFlexGrid,
  EuiTabs,
  EuiTab,
} from '@elastic/eui'
import KpiService from '../services/kpi.service'

import Chart from '../components/Chart'

function Charts(props) {
  const { kpiDocument } = props

  //Tabs log
  const [selectedTabId, setSelectedTabId] = useState('log_compact')
  const [selectedTabStacked, setSelectedTabStacked] = useState(false)

  //Tabs Logs
  const logTabs = [
    {
      id: 'log_compact',
      stacked: false,
      name: 'Logs',
    },
    {
      id: 'log_full',
      stacked: true,
      name: 'Logs détaillés',
    },
  ]

  const onSelectedTabChanged = (tab) => {
    setSelectedTabId(tab.id)
    setSelectedTabStacked(tab.stacked)
  }

  const renderTabs = () => {
    return logTabs.map((tab, index) => (
      <EuiTab
        key={index}
        onClick={() => onSelectedTabChanged(tab)}
        isSelected={tab.id === selectedTabId}
      >
        {tab.name}
      </EuiTab>
    ))
  }

  return (
    <>
      {/* {JSON.stringify(kpiDocument)} */}
      <EuiFlexGrid columns={3} responsive={true}>
        <EuiFlexItem>
          <EuiPanel>
            {kpiDocument.er_supervise ? (
              <Chart
                label={
                  KpiService.kpisLabel[
                  KpiService.kpisGroup.indexOf('er_supervise')
                  ]
                }
                name="er_supervise"
                kpiDocument={kpiDocument}
              />
            ) : (
              <></>
            )}
          </EuiPanel>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiPanel>
            {kpiDocument.mitre_attack ? (
              <Chart
                label={
                  KpiService.kpisLabel[
                  KpiService.kpisGroup.indexOf('mitre_attack')
                  ]
                }
                name="mitre_attack"
                kpiDocument={kpiDocument}
              />
            ) : (
              <></>
            )}
          </EuiPanel>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiPanel>
            {kpiDocument.perimetre_supervise ? (
              <Chart
                label={
                  KpiService.kpisLabel[
                  KpiService.kpisGroup.indexOf('perimetre_supervise')
                  ]
                }
                name="perimetre_supervise"
                kpiDocument={kpiDocument}
              />
            ) : (
              <></>
            )}
          </EuiPanel>
        </EuiFlexItem>
      </EuiFlexGrid>
      <EuiFlexGrid columns={1} responsive={true}>
        <EuiFlexItem>
          <EuiPanel>
            {/* {JSON.stringify(kpiDocument)} */}
            {kpiDocument.log ? (
              <>
                <Chart
                  label={
                    KpiService.kpisLabel[KpiService.kpisGroup.indexOf('log')]
                  }
                  stacked={selectedTabStacked}
                  name="log_full"
                  kpiDocument={kpiDocument}
                  selectedTabId = {selectedTabId}
                />
                <EuiTabs>{renderTabs()}</EuiTabs>
              </>
            ) : (
              <></>
            )}
          </EuiPanel>
        </EuiFlexItem>
      </EuiFlexGrid>
    </>
  )
}

export default Charts
